module.exports = __webpack_public_path__ + "img/4_d510c509d.png";